import type { TBackGround } from '../models';

export function prepareUrl(url: string, params: Record<string, string | number>): string {
    return `${url}?${Object.keys(params)
        .map(key => `${key}=${encodeURIComponent(params[key])}`)
        .join('&')}`;
}

export const goToSearch = (value: string, searchId: number, searchUrl: string) => {
    // eslint-disable-next-line check-window-access/check-window-access
    window.location.assign(
        prepareUrl(searchUrl, {
            searchid: searchId,
            text: value,
            web: 0,
        })
    );
};

type TConfig = {
    BACKGROUND: TBackGround;
    SEARCH_ID: number;
    SEARCH_PLACEHOLDER: string;
};

export const TOP_MENU_CONFIG: TConfig = {
    SEARCH_ID: 2389978,
    SEARCH_PLACEHOLDER: 'Что вы хотите найти',
    BACKGROUND: 'default',
};
